export const sampleData = [
    {
        title:'하남시 14개소',
        point_cnt: 14,
        camera_cnt: 18,
        // rec_list:['11/18(토) - 08~23','11/20(월)'],
        rec_list: '11/18(토) - 08~23,11/20(월)',
        rec_timeH: 7,
        cname:'동림티엔에스',
        set_person: ['민준식'],
        set_from: '2023-11-14',
        set_to: '2023-11-20',
        coding_from: '2023-11-21',
        coding_to: '2023-11-23',
        odate:'',
        pro_st:'I',
        pro_st_nm:'설치',
        alert: false
    },
    {
        title:'목동 원단위조사',
        point_cnt: 3,
        camera_cnt: 5,
        // rec_list:['11/15(수) - 06~22'],
        rec_list: '11/15(수) - 06~22',
        rec_timeH: 16,
        cname:'백산티디엠',
        set_person: ['이동규'],
        set_from: '2023-11-13',
        set_to: '2023-11-15',
        coding_from: '2023-11-16',
        coding_to: '2023-11-18',
        odate:'',
        pro_st:'S',
        pro_st_nm:'코딩',
        coding_progress:90,
        alert: false
    },
    {
        title:'평택시 도로교통량 조사 27개소',
        point_cnt: 27,
        camera_cnt: 31,
        // rec_list:['11/16(목) - 07~07'],
        rec_list: '11/16(목) - 07~07',
        rec_timeH: 24,
        cname:'평택시청',
        set_person: ['오시율'],
        set_from: '2023-11-14',
        set_to: '2023-11-18',
        coding_from: '2023-12-01',
        coding_to: '',
        odate:'',
        pro_st:'S',
        pro_st_nm:'코딩',
        // coding_progress:10,
        alert: false
    },
    {
        title:'가평군 보행량조사',
        point_cnt: 15,
        camera_cnt: 15,
        // rec_list:['11/17(금) - 07~19'],
        rec_list: '11/17(금) - 07~19',
        rec_timeH: 6,
        cname:'에스원엔지니어링',
        set_person: ['오시율'],
        set_from: '2023-11-13',
        set_to: '2023-11-17',
        coding_from: '2023-11-18',
        coding_to: '2023-11-20',
        odate:'',
        pro_st:'S',
        pro_st_nm:'코딩',
        coding_progress:90,
        alert: true
    },
    {
        title:'창동 1-28 일원 8개소',
        point_cnt: 8,
        camera_cnt: 9,
        // rec_list:['11/17(금) - 07~19'],
        rec_list:'11/17(금) - 07~19',
        rec_timeH: 6,
        cname:'진성',
        set_person: ['오시율'],
        set_from: '2023-11-13',
        set_to: '2023-11-17',
        coding_from: '2023-11-18',
        coding_to: '2023-11-20',
        odate:'',
        pro_st:'S',
        pro_st_nm:'코딩',
        coding_progress:80,
        alert: false
    },
    {
        title:'고양시 55개소',
        point_cnt: 55,
        camera_cnt: 90,
        // rec_list:['11/17(금) - 07~19'],
        rec_list: '11/17(금) - 07~19',
        rec_timeH: 6,
        cname:'동림티엔에스',
        set_person: ['민준식외2명'],
        set_from: '2023-11-15',
        set_to: '2023-11-18',
        coding_from: '2023-11-19',
        coding_to: '2023-11-23',
        odate:'',
        pro_st:'S',
        pro_st_nm:'코딩',
        coding_progress:10,
        alert: false
    },
    {
        title:'동두천시 3개소',
        point_cnt: 3,
        camera_cnt: 3,
        // rec_list:['11/17(금) - 00~24'],
        rec_list:'11/17(금) - 00~24',
        rec_timeH: 24,
        cname:'개인',
        set_person: ['오시율'],
        set_from: '2023-11-16',
        set_to: '2023-11-17',
        coding_from: '2023-11-18',
        coding_to: '2023-11-20',
        odate:'',
        pro_st:'S',
        pro_st_nm:'코딩',
        coding_progress:90,
        alert: false
    },
    {
        title:'대죽리 4개소',
        point_cnt: 4,
        camera_cnt: 4,
        // rec_list:['11/17(금) - 07~19'],
        rec_list:'11/17(금) - 07~19',
        rec_timeH: 6,
        cname:'유티에스기술',
        set_person: ['민준식'],
        set_from: '2023-11-16',
        set_to: '2023-11-17',
        coding_from: '2023-11-18',
        coding_to: '2023-11-20',
        odate:'',
        pro_st:'S',
        pro_st_nm:'코딩',
        coding_progress:90,
        alert: false
    },
    {
        title:'인천 청라 2개소',
        point_cnt: 2,
        camera_cnt: 4,
        // rec_list:['11/17(토) - 07~19','11/18(토), 11/19(일)'],
        rec_list: '11/17(토) - 07~19\n11/18(토) 11/19(일)',
        rec_timeH: 6,
        cname:'신우기술단',
        set_person: ['민준식'],
        set_from: '2023-11-14',
        set_to: '2023-11-19',
        coding_from: '2023-11-20',
        coding_to: '2023-11-22',
        odate:'',
        pro_st:'S',
        pro_st_nm:'코딩',
        coding_progress:10,
        alert: false
    },
    {
        title:'은명초교 인근 교통량조사(14일,18일)',
        point_cnt: 4,
        camera_cnt: 4,
        // rec_list:['11/10(금) - 07~19','11/11(토) - 07~19'],
        rec_list: '11/10(금) - 07~19\n11/11(토) - 07~19',
        rec_timeH: 6,
        cname:'건영이앤씨',
        set_person: ['이동규'],
        set_from: '2023-11-13',
        set_to: '2023-11-18',
        coding_from: '2023-11-15',
        coding_to: '2023-11-21',
        odate:'',
        pro_st:'S',
        pro_st_nm:'코딩',
        coding_progress:90,
        alert: true
    },

]